<template>
  <BusyButton
    :disabled="disabled"
    :is-loading="isLocalLoading"
    :expanded="expanded"
    :small="small"
    :inline="inline"
    :variant="variant"
    @click="onClick"
  >
    <slot></slot>
  </BusyButton>
</template>

<script setup>
import { ref, watch } from 'vue';
import BusyButton from './BusyButton';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  variant: {
    /**
     * @type {import('vue').PropType<('primary' | 'secondary' | 'emphasis')>}
     */
    type: String,
    /**
     * @param {String} value
     */
    validator(value) {
      return ['emphasis', 'primary', 'secondary'].includes(value);
    },
    default: 'emphasis',
  },
});

const isLocalLoading = ref(false);

watch(
  () => props.isLoading,
  (value) => {
    if (value) {
      return;
    }
    isLocalLoading.value = value;
  },
);

const onClick = () => {
  isLocalLoading.value = true;
};
</script>
